import React, { useState, useEffect, memo } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setDeleteCompany } from '../../redux/reducers/CompanySlice';

const RestoreTimer = memo(({ deletionTsSeconds, companyID }) => {
    const [label, setLabel] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        const updateLabel = () => {
            const now = moment();
            const expiresAt = moment(deletionTsSeconds * 1000);
            const diffMs = expiresAt.diff(now);
            const dur = moment.duration(diffMs);

            if (dur.asSeconds() <= 0) {
                setLabel('');
                dispatch(setDeleteCompany(companyID))
            } else if (dur.asDays() >= 1) {
                const days = Math.ceil(dur.asDays());
                setLabel(`${days} day${days > 1 ? 's' : ''} left to restore`);
            } else {
                const hrs = Math.floor(dur.asHours());
                const mins = dur.minutes();
                const secs = dur.seconds();
                setLabel(
                    `${hrs}h ${mins}m ${secs}s left to restore`
                );
            }
        };

        updateLabel();
        const tid = setInterval(updateLabel, 1000);
        return () => clearInterval(tid);
    }, [deletionTsSeconds, companyID, setDeleteCompany]);

    return label ? <span>({label})</span> : null;
});

export default RestoreTimer;
